<template>
    <property-base :label="label.text" :forInput="label.for">
        <template v-for="(condition, idx) in newValue">
            <div class="row" :key="condition.key">
                <div class="col-10">
                    <connection-action :value="condition"
                                  :availableConditions="conditions"
                                  :canWrite="canWrite"
                                  @set-condition="condition.conditionId = $event"
                                  @set-operator="condition.operator = $event"
                    />
                </div>
                <div class="col-2 d-flex flex-column">
                    <button
                            v-if="newValue.length !== 1"
                            class="btn btn-outline-danger w-100"
                            :class="{ disabled: !canWrite }"
                            @click="removeConditionAt(idx)"
                    >
                        <i class="fa fa-minus"></i>
                    </button>
                    
                    <button
                            v-if="idx + 1 === newValue.length"
                            
                            class="btn btn-outline-secondary mt-auto"
                            :class="[addEnabled ? '' : 'disabled']"
                            @click="addCondition()"
                            @mouseover="addBtnHover"
                            @mouseleave="noAvailableConditionsError = false"
                    >
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>
            
        </template>

        <div v-if="noAvailableConditionsError" class="row">
            <div class="col-12">
                <error-message message="There are no more conditions available for this connection." />
            </div>
        </div>
    </property-base>
</template>

<script>

import guid from '../../../../../../Util/Mixins/guid';
import resources from '../../../../../../Util/Mixins/resources';
import permissionsMixin from '../../../../Mixins/journey-permissions';

import JourneyConnectionPropertyBase from './../JourneyConnectionPropertyBase.vue';
import JourneyConnectionAction from './JourneyConnectionAction.vue';
import ErrorMessage from '../../../../../../Components/Errors/ErrorMessage.vue';

export default {
    name: 'journey-connection-actions',
    components: {
        'PropertyBase': JourneyConnectionPropertyBase,
        'ConnectionAction': JourneyConnectionAction,
        ErrorMessage
    },
    mixins: [resources, guid, permissionsMixin],
    created() {
        const vm = this;
        
        vm.value.forEach((v) => {
            vm.newValue.push({
                conditionId: v.conditionId,
                operator: v.operator,
                key: vm.guid()
            });
        });

        if(vm.newValue.length === 0){
            vm.newValue.push(vm.createCondition());   
        }
    },
    methods: {
        validate() {
            this.showError = this.newValue === [];
            return !this.showError;
        },
        createCondition(){
            return {
                conditionId: undefined,
                operator: undefined,
                key: this.guid()
            };
        },
        addCondition() {
            if(this.addEnabled) {
                this.newValue.push(this.createCondition());
            }
        },
        addBtnHover() {
            if(!this.conditionsAvailable) {
                this.noAvailableConditionsError = true;
            }
        },
        removeConditionAt(conditionIndex)
        {
            if(this.canWrite){
                this.newValue.splice(conditionIndex, 1);   
            }
        }
    },
    computed: {
        label() {
            return { 
                text: this.resource('JourneyBuilder_conditionsettings_Condition_DisplayName'),
                for: this.elementName
            }
        },
        availableConditions() {
            const currentConditionIds = this.newValue
                .filter((v) => v.conditionId !== undefined)
                .map((v) => {
                    return v.conditionId;
                });

            const available = this.conditions.filter(
                (condition) => currentConditionIds.indexOf(condition.id) === -1
            );
            
            return available;
        },
        conditionsAvailable() {
            return this.availableConditions.length !== 0;
        },
        addEnabled() {
            return this.conditionsAvailable && this.canWrite;
        }
    },
    watch: {
        newValue: {
            handler(value) {

                if(value != this.value) {
                    this.$emit('input', value);
                }
            },
            deep: true
        }
    },
    data() {
        return {
            newValue: [],
            elementName: "Actions",
            noAvailableConditionsError: false,
            showError: false
        }
    },
    props: {
        value: {
            type: Array,
            required: true
        },
        conditions: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>

</style>